import type {CancelablePromise} from '../types/CancelablePromise';
import type {Series} from '../types/Series';
import type {SeriesTypeEnum} from '../types/SeriesTypeEnum';
import {request as __request} from '../utils/request';

export class SeriesService {
  /**
   * @returns Series
   * @throws ApiError
   */
  public static getSeriesList({
    search,
    type,
    authorization,
    xBranch,
  }: {
    search?: string;
    type?: Array<SeriesTypeEnum>;
    authorization?: string;
    xBranch?: string;
  }): CancelablePromise<Array<Series>> {
    return __request({
      method: 'GET',
      url: '/dms/v1/series',
      headers: {
        Authorization: authorization,
        ...(xBranch ? {'X-Branch': xBranch} : {}),
      },
      query: {
        search,
        type,
      },
    });
  }

  /**
   * @returns Series
   * @throws ApiError
   */
  public static getSeries({
    seriesId,
    authorization,
  }: {
    seriesId: string;
    authorization?: string;
  }): CancelablePromise<Series> {
    return __request({
      method: 'GET',
      url: '/dms/v1/series/{seriesId}',
      path: {
        seriesId,
      },
      headers: {
        Authorization: authorization,
      },
    });
  }
}
